<script lang="ts">
    import Fa from 'svelte-fa'
    import { faThList, faUser, faEdit, faPlus, faMinus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import { Service } from '../../modules/posApi/services/service'
    import { ServicesRepository } from '../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../modules/posApi/services/services.service'
    import Popover from '../_common/popover.svelte'
    import { createEventDispatcher, onMount } from 'svelte'
    import Services from '../account/services/services.svelte'
    import dayjs from 'dayjs'
    import Products from '../account/products/products.svelte'
    import Consumables from '../account/consumables/consumables.svelte'
    import type { BalanceResult } from '../../modules/posApi/balance-results/balance-result'
    import Zinput from '../_common/z/zinput.svelte'
    import ZinputSearchTrigger from '../_common/z/zinput/zinput-search-trigger.svelte'
    import Zoption from '../_common/z/zoption.svelte'
    import type { GridButton } from '../_common/z/zgrid'

    const dispatch = createEventDispatcher()

    export let service: Service = null
    export let balance_parentServicesOnInvoicesId: string = null
    export let balanceResultId: string = null
    export let invoiceId: string = null

    export let disabled: boolean = false
    export let small = false
    export let label = ''
    export let type = 'service'
    export let personId: string = null
    export let balance = false
    export let duration
    export let price
    export let onlyWithBalance = false
    export let scheduleId: string = null
    export let size: string = ''
    export let v2: boolean = false

    // título da lista completa abaixo do resultado da busca — só troca quando o filtro é exclusivamente
    // de um tipo (ex: aba Insumos); combinações (ex: "product,consumable") mantêm o texto genérico.
    $: allResultsTitle = type === 'consumable' ? 'Todos os insumos' : type === 'product' ? 'Todos os produtos' : 'Todos os produtos e serviços'

    const serviceR = new ServicesRepository()
    const servicesS = new ServicesService(serviceR)
    let query = ''
    let services: Service[] = []
    let personBalance: BalanceResult[] = []

    let delay = null
    async function search(query) {
        // usado apenas pelo modo legado (v2=false): não passa pelo ZinputSearchTrigger, então o debounce fica aqui.
        if (!loaded) return
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            await loadServices(query, 300)
            if (services.length === 0) dropHelper = 'Não encontrado.'
        }, 500)
    }

    async function searchV2(q: string) {
        // usado pelo ZinputSearchTrigger, que já debounce a chamada — sem debounce adicional aqui.
        if (!loaded) return
        await loadServices(q, 300)
    }

    async function getFirst100() {
        await loadServices(null, 1000)
    }

    async function loadServices(query: string, limit: number) {
        const _services = await servicesS.getAll({ query, pageSize: limit, type: type.split(',') })
        services = _services.filter((el) => el.type === 'package')
        services = services.concat(_services.filter((el) => el.type === 'service'))
        services = services.concat(_services.filter((el) => el.type === 'product'))
        services = services.concat(_services.filter((el) => el.type === 'consumable'))
        if (scheduleId) {
            services = services.filter((el) => !el.schedulers || el.schedulers.length === 0 || el.schedulers.includes(scheduleId))
        }
        await getBalance(query)
    }

    async function getBalance(query: string = null) {
        personBalance = []
        if (balance && personId) {
            personBalance = await window.api.pos.balanceResults.getAll({ active: true, personId, service: true, query })
            personBalance = personBalance.filter((el) => el.unscheduled > 0)
            console.log('peronsBalance', personBalance)
            if (scheduleId) {
                personBalance = personBalance.filter(
                    (el) => !el.service.schedulers || el.service.schedulers.length === 0 || el.service.schedulers.includes(scheduleId),
                )
            }
        }
        console.log('balance', balance, personId, personBalance)
    }

    async function select(index, close?: () => void) {
        service = services[index]
        balance_parentServicesOnInvoicesId = null
        balanceResultId = null
        invoiceId = null

        if (Array.isArray(service?.services)) {
            service.services = await window.api.utils.utils.assignServicesFromObject(service.services)
        }

        query = ''
        personBalance = []
        services = []
        close?.()
        dispatch('change', service)
        console.log('service_selected', service)
    }

    async function selectFromBalance(index, item, close?: () => void) {
        if (item.unscheduled <= 0 && !!item.parentServicesOnInvoicesId) {
            window.error(
                'Saldo insuficiente.\nO cliente não possui sessões pendentes de agendamento para este pacote.\n\nAinda assim, caso queira lançar este serviço para o cliente selecione o serviço através da lista de serviços, e não do pacote do cliente.',
            )
            return
        }
        balance_parentServicesOnInvoicesId = personBalance[index].parentServicesOnInvoicesId
        balanceResultId = personBalance[index].balanceResultId
        invoiceId = personBalance[index].invoiceId

        service = personBalance[index].service
        if (Array.isArray(service?.services)) {
            service.services = await window.api.utils.utils.assignServicesFromObject(service.services)
        }
        query = ''
        console.log('service_selected', service, personBalance[index])
        personBalance = []
        services = []
        close?.()
        dispatch('change', service)
    }

    async function loadService(serviceId) {
        if (serviceId) {
            service = await servicesS.getOne(serviceId)
            if (Array.isArray(service?.services)) {
                service.services = await window.api.utils.utils.assignServicesFromObject(service.services)
            }
            _showDrop = false
        }
    }

    function clear() {
        if (service.type === 'package') return
        service = null
        _showDrop = false
        dispatch('clear')
    }

    let showFormService = false
    let showFormProduct = false
    let showFormConsumable = false
    let _showSelect = false
    function newService() {
        service = new Service()
        if (type === 'service') {
            showFormService = true
            return
        }
        if (type === 'product') {
            showFormProduct = true
            return
        }
        if (type === 'consumable') {
            showFormConsumable = true
            return
        }
        _showSelect = !_showSelect
    }

    function editService() {
        if (service.type === 'product') {
            showFormProduct = true
        } else if (service.type === 'consumable') {
            showFormConsumable = true
        } else {
            showFormService = true
        }
    }

    async function hideForm(event) {
        showFormProduct = false
        showFormService = false
        showFormConsumable = false
        _showSelect = false
        await getFirst100()
        // if (event.detail?.serviceId) {
        //     service = event.detail
        // }
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
    }

    function hideDrop(event) {
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    let loaded = false
    onMount(async () => {
        await getFirst100()
        loaded = true
    })

    $: {
        if (service?.serviceId && !service?.createdAt) loadService(service.serviceId)
        if (!v2) search(query)
    }

    function friendlyName(p: Service, expiresAt: Date = null) {
        let name = p?.name || ''
        if (p?.status <= 0) name += ' (excluído)'
        return name
    }

    // cor da etiqueta por tipo, no tom suave das listas (ver zoption.svelte)
    function badgeTone(type: string): 'neutral' | 'green' | 'amber' | 'blue' | 'teal' {
        if (type === 'service') return 'green'
        if (type === 'package') return 'amber'
        if (type === 'product') return 'blue'
        if (type === 'consumable') return 'teal'
        return 'neutral'
    }

    function friendlyType(type: string, child = false, purchaseAt: Date) {
        if (type === 'service') {
            if (child) {
                if (purchaseAt) {
                    return 'Pacote de ' + dayjs(purchaseAt).format('DD/MM/YY')
                } else {
                    return 'Pacote' // em tese nunca deve ocorrer. sempre terá um purchaseAt
                }
            }
            return 'Serviço'
        }
        if (type === 'package') return 'Pacote'
        if (type === 'product') return 'Produto'
        if (type === 'consumable') return 'Consumível'
        return type
    }

    const btnClear: GridButton = {
        label: '',
        icon: faTimes,
        callback: clear,
    }
    const btnNewService: GridButton = {
        label: '',
        icon: faPlus,
        callback: newService,
    }
</script>

{#if showFormService}
    <Popover on:close={hideForm} title="Serviço" height="200px" width="970px">
        <Services serviceId={service.serviceId} form={true} on:close={hideForm} />
    </Popover>
{/if}
{#if showFormProduct}
    <Popover on:close={hideForm} title="Produto" height="200px" width="970px">
        <Products serviceId={service.serviceId} form={true} on:close={hideForm} />
    </Popover>
{/if}
{#if showFormConsumable}
    <Popover on:close={hideForm} title="Insumo" height="200px" width="970px">
        <Consumables serviceId={service.serviceId} form={true} on:close={hideForm} />
    </Popover>
{/if}
<div class="query query_{size}">
    <div class="input-group custom-control" class:input-group-sm={small === true}>
        {#if v2}
            {#if service && service.serviceId}
                <Zinput acts={[btnClear]} label={label || ''} disabled value={friendlyName(service)} type="text"></Zinput>
            {:else}
                <ZinputSearchTrigger bind:query label={label || ''} acts={[btnNewService]} search={searchV2} minLength={0} let:close>
                    {#if services.length === 0 && personBalance.length === 0}
                        <div class="p-2 text-muted">Não encontrado.</div>
                    {:else}
                        {#if personBalance.length > 0}
                            <Zoption header={true} title="Saldos do cliente">
                                <Fa slot="icon" icon={faUser} />
                            </Zoption>
                            {#each personBalance as item, index}
                                <Zoption
                                    title={friendlyName(item.service, item.expiresAt)}
                                    badge={friendlyType(item.service.type, !!item.parentServicesOnInvoicesId, item.purchaseAt)}
                                    badgeTone={badgeTone(item.service.type)}
                                    details={[
                                        'Duração: ' + dayjs(new Date(0, 0, 0, 0, item.service.duration, 0)).format('HH:mm'),
                                        'Saldo: ' + item.unscheduled,
                                        item.expiresAt ? 'Vence ' + dayjs(item.expiresAt).format('DD/MM/YYYY') : '',
                                    ]}
                                    on:click={() => selectFromBalance(index, item, close)}
                                />
                            {/each}
                        {/if}
                        <Zoption header={true} title={allResultsTitle}>
                            <Fa slot="icon" icon={faThList} />
                        </Zoption>

                        {#each services as p, index}
                            {#if !onlyWithBalance || p.price === 0}
                                <Zoption
                                    title={friendlyName(p)}
                                    badge={friendlyType(p.type, false, null)}
                                    badgeTone={badgeTone(p.type)}
                                    details={[
                                        duration && p.type === 'service' ? 'Duração: ' + dayjs(new Date(0, 0, 0, 0, p.duration, 0)).format('HH:mm') : '',
                                        price ? 'Preço: ' + p.price.toFixed(2) : '',
                                    ]}
                                    on:click={() => select(index, close)}
                                />
                            {/if}
                        {/each}
                    {/if}
                </ZinputSearchTrigger>
            {/if}
        {:else if service && service.serviceId}
            {#if label}
                <div class="input-group-text">{label}</div>
            {/if}

            <input class="form-control" class:form-control-sm={small === true} disabled value={friendlyName(service)} type="text" />
            <!-- <button on:click={editService} class="btn btn-secondary"><Fa icon={faEdit} /></button> -->
            {#if !disabled && service?.type !== 'package'}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}><Fa icon={faTimes} /></button>
            {/if}
        {:else}
            <input
                class="form-control btn-end select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
            />
            <button on:click={newService} class="btn btn-secondary">
                {#if _showSelect}
                    <Fa icon={faMinus} />
                {:else}
                    <Fa icon={faPlus} />
                {/if}
            </button>
        {/if}
    </div>

    {#if _showSelect}
        <div class="listSelect">
            <button class="btn btn-secondary btn-sm" on:click={() => (showFormService = true)}>Novo serviço</button>
            <button class="btn btn-secondary btn-sm" on:click={() => (showFormProduct = true)}>Novo produto</button>
            <button class="btn btn-secondary btn-sm" on:click={() => (showFormConsumable = true)}>Novo insumo</button>
        </div>
    {/if}

    {#if _showDrop}
        <div class="list scroll-dark">
            {#if services.length === 0}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#if personBalance.length > 0}
                    <div class="service-title">Saldos do cliente</div>
                    {#each personBalance as item, index}
                        <button
                            on:click={() => {
                                selectFromBalance(index, item)
                            }}
                        >
                            <div class="-label">
                                <div class="badge badge_{item.service.type}">
                                    {friendlyType(item.service.type, !!item.parentServicesOnInvoicesId, item.purchaseAt)}
                                </div>
                                <div class="-label_name">
                                    <div>
                                        {friendlyName(item.service, item.expiresAt)}
                                    </div>
                                    {#if item.expiresAt}
                                        <div class="-label_name-expires">
                                            Vence {window.api.utils.utils.dateFriendly(item.expiresAt)}
                                            ({dayjs(item.expiresAt).format('DD/MM/YYYY')})
                                        </div>
                                    {/if}
                                </div>
                            </div>
                            <div class="-balance">
                                {item.unscheduled}
                            </div>
                            <div class="-duration">
                                {dayjs(new Date(0, 0, 0, 0, item.service.duration, 0)).format('HH:mm')}
                            </div>
                        </button>
                    {/each}
                {/if}
                <div class="service-title">{allResultsTitle}</div>

                {#each services as p, index}
                    {#if !onlyWithBalance || p.price === 0}
                        <button
                            on:click={() => {
                                select(index)
                            }}
                        >
                            <div class="-label">
                                <div class="badge badge_{p.type}">
                                    {friendlyType(p.type, false, null)}
                                </div>
                                <div class="-label_name">
                                    {friendlyName(p)}
                                </div>
                            </div>

                            {#if duration && p.type === 'service'}
                                <div class="-duration">
                                    {dayjs(new Date(0, 0, 0, 0, p.duration, 0)).format('HH:mm')}
                                </div>
                            {/if}
                            {#if price}
                                <div class="-duration text-end">
                                    {p.price.toFixed(2)}
                                </div>
                            {/if}
                        </button>
                    {/if}
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }

    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 400px;
        background: #eee;
        color: black;
    }
    .list .service-title {
        font-size: 16px;
        background: #98eecc;
        padding: 2px 4px;
    }
    .list button {
        flex-grow: 1;
        padding: 4px 4px 4px 4px;
        text-align: left;
        display: flex;
        border: 0px;
        border-bottom: 1px solid #99999960;
    }
    .list button .-label {
        flex-grow: 1;
        display: flex;
        align-items: center;
    }
    .list button .-balance {
        flex: 0 0 60px;
        padding-right: 24px;
        text-align: right;
    }
    .list button .-duration {
        flex: 0 0 60px;
    }

    .list button:hover {
    }
    /* a lista de resultados agora é o Zoption (_common/z/zoption.svelte) */

    .listSelect {
        position: absolute;
        z-index: 1;
        background-color: #222;
        max-width: 180px;
        right: 0px;
        display: flex;
        flex-direction: column;
    }

    .-label_name > * {
        border: 0px solid red;
    }
    .-label_name-expires {
        font-size: 13px;
        opacity: 0.7;
        margin-top: -6px;
    }

    .query_lg .input-group > * {
        padding: 9px;
    }
</style>
